import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Menu } from "lucide-react";
 * // Use <Menu /> instead
 */
export const MenuIcon = createSVGWrapper(
  <>
    <path
      fill="currentColor"
      d="M4 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1ZM4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1ZM5 16a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z"
    />
  </>
);
